import React from 'react';
import { Box } from '@mui/material';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import dayjs from 'dayjs';

import { PropertyTextInput } from '@paragon/client-tools';

import { LineSelector } from '../../LineSelector';

interface ScheduleLineGroupPropertiesProps {
  readonly scheduleLineGroupName: string | null;
  readonly setScheduleLineGroupName: (newScheduleLineGroupName: string | null) => void;
  readonly scheduleLineGroupNameError: boolean;
  readonly selectedLineGuid: string | null;
  readonly setSelectedLineGuid: (lineGuid: string | null) => void;
  readonly selectedLineGuidError: boolean;
  readonly scheduledDate: string | null;
  readonly setScheduledDate: (date: string | null) => void;
}

export function ScheduleLineGroupProperties(props: ScheduleLineGroupPropertiesProps) {
  const {
    scheduleLineGroupName,
    setScheduleLineGroupName,
    scheduleLineGroupNameError,
    selectedLineGuid,
    setSelectedLineGuid,
    selectedLineGuidError,
    scheduledDate,
    setScheduledDate,
  } = props;
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column' }}>
      <PropertyTextInput
        property="Schedule Line Group Name"
        value={scheduleLineGroupName ?? ''}
        submit={(newScheduleLineGroupName) => void setScheduleLineGroupName(newScheduleLineGroupName.trim())}
        error={scheduleLineGroupNameError}
      />
      <Box sx={{ mb: 2 }}>
        <LineSelector selectedLineGuid={selectedLineGuid} submit={setSelectedLineGuid} error={selectedLineGuidError} />
      </Box>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <DatePicker
          value={scheduledDate ? dayjs(scheduledDate) : null}
          label="Production Date (optional)"
          onChange={(date) => void setScheduledDate(date?.format('YYYY-MM-DDTHH:mm:ss') ?? null)}
        />
      </LocalizationProvider>
    </Box>
  );
}
